document.addEventListener('DOMContentLoaded', function() {
    const widgets = document.querySelectorAll('.edas-widget-home-carousel');

    widgets.forEach(function(widget) {
        const track = widget.querySelector('.edas-carousel-track');
        const slides = widget.querySelectorAll('.edas-carousel-slide');
        const prevBtn = widget.querySelector('.edas-carousel-prev');
        const nextBtn = widget.querySelector('.edas-carousel-next');

        if (track && slides.length > 1) {
            let currentIndex = 0;
            const totalSlides = slides.length;
            let autoPlayInterval;

            function goToSlide(index) {
                if (index < 0) {
                    index = totalSlides - 1;
                } else if (index >= totalSlides) {
                    index = 0;
                }
                currentIndex = index;
                const slideWidth = slides[0].clientWidth;
                track.scrollTo({
                    left: slideWidth * currentIndex,
                    behavior: 'smooth'
                });
            }

            function nextSlide() {
                goToSlide(currentIndex + 1);
            }

            function prevSlide() {
                goToSlide(currentIndex - 1);
            }

            function startAutoPlay() {
                stopAutoPlay();
                autoPlayInterval = setInterval(nextSlide, 3000);
            }

            function stopAutoPlay() {
                if (autoPlayInterval) {
                    clearInterval(autoPlayInterval);
                }
            }

            if (nextBtn) {
                nextBtn.addEventListener('click', function() {
                    nextSlide();
                    startAutoPlay();
                });
            }

            if (prevBtn) {
                prevBtn.addEventListener('click', function() {
                    prevSlide();
                    startAutoPlay();
                });
            }

            let isScrolling;
            track.addEventListener('scroll', function() {
                window.clearTimeout(isScrolling);
                isScrolling = setTimeout(function() {
                    const slideWidth = slides[0].clientWidth;
                    const newIndex = Math.round(track.scrollLeft / slideWidth);
                    if (newIndex !== currentIndex) {
                        currentIndex = newIndex;
                    }
                }, 66);
            }, { passive: true });

            track.addEventListener('mouseenter', stopAutoPlay);
            track.addEventListener('mouseleave', startAutoPlay);
            track.addEventListener('touchstart', stopAutoPlay, { passive: true });
            track.addEventListener('touchend', startAutoPlay, { passive: true });

            startAutoPlay();
        }

        // Featured content strip: overflow-aware scroll of fixed-width cards
        const featuredRoot = widget.querySelector('.edas-carousel-featured');
        const featuredTrack = featuredRoot
            ? featuredRoot.querySelector('.edas-carousel-featured-track')
            : null;
        const featuredCards = featuredTrack
            ? featuredTrack.querySelectorAll('.edas-carousel-featured-card')
            : [];
        const featuredPrev = featuredRoot
            ? featuredRoot.querySelector('.edas-carousel-featured-prev')
            : null;
        const featuredNext = featuredRoot
            ? featuredRoot.querySelector('.edas-carousel-featured-next')
            : null;

        if (featuredRoot && featuredTrack && featuredCards.length) {
            let featuredInterval = null;
            let featuredPaused = false;

            function getFeaturedStep() {
                const card = featuredCards[0];
                if (!card) {
                    return 0;
                }
                const styles = window.getComputedStyle(featuredTrack);
                const gap = parseFloat(styles.columnGap || styles.gap) || 0;
                return card.offsetWidth + gap;
            }

            function needsScroll() {
                return featuredTrack.scrollWidth > featuredTrack.clientWidth + 1;
            }

            function setButtonsVisible(visible) {
                [featuredPrev, featuredNext].forEach(function(btn) {
                    if (!btn) {
                        return;
                    }
                    if (visible) {
                        btn.removeAttribute('hidden');
                    } else {
                        btn.setAttribute('hidden', '');
                    }
                });
            }

            function stopFeaturedAutoPlay() {
                if (featuredInterval) {
                    clearInterval(featuredInterval);
                    featuredInterval = null;
                }
            }

            function scrollByCard(direction) {
                const step = getFeaturedStep();
                if (!step) {
                    return;
                }

                const maxScroll = Math.max(0, featuredTrack.scrollWidth - featuredTrack.clientWidth);
                let nextLeft = featuredTrack.scrollLeft + direction * step;

                if (direction > 0 && nextLeft >= maxScroll - 2) {
                    nextLeft = 0;
                } else if (direction < 0 && featuredTrack.scrollLeft <= 2) {
                    nextLeft = maxScroll;
                } else {
                    nextLeft = Math.max(0, Math.min(nextLeft, maxScroll));
                }

                featuredTrack.scrollTo({
                    left: nextLeft,
                    behavior: 'smooth'
                });
            }

            function startFeaturedAutoPlay() {
                stopFeaturedAutoPlay();
                if (featuredPaused || !needsScroll() || featuredCards.length < 2) {
                    return;
                }
                featuredInterval = setInterval(function() {
                    scrollByCard(1);
                }, 4500);
            }

            function updateOverflowUI() {
                const overflow = needsScroll();
                featuredRoot.classList.toggle('has-overflow', overflow);
                setButtonsVisible(overflow && featuredCards.length > 1);

                if (overflow) {
                    if (!featuredPaused) {
                        startFeaturedAutoPlay();
                    }
                } else {
                    stopFeaturedAutoPlay();
                    featuredTrack.scrollLeft = 0;
                }
            }

            function revealFeatured() {
                if (!featuredRoot.classList.contains('is-ready')) {
                    featuredRoot.classList.add('is-ready');
                }
            }

            if (featuredNext) {
                featuredNext.addEventListener('click', function() {
                    scrollByCard(1);
                    startFeaturedAutoPlay();
                });
            }

            if (featuredPrev) {
                featuredPrev.addEventListener('click', function() {
                    scrollByCard(-1);
                    startFeaturedAutoPlay();
                });
            }

            featuredTrack.addEventListener('mouseenter', function() {
                featuredPaused = true;
                stopFeaturedAutoPlay();
            });
            featuredTrack.addEventListener('mouseleave', function() {
                featuredPaused = false;
                startFeaturedAutoPlay();
            });
            featuredTrack.addEventListener('touchstart', function() {
                featuredPaused = true;
                stopFeaturedAutoPlay();
            }, { passive: true });
            featuredTrack.addEventListener('touchend', function() {
                featuredPaused = false;
                startFeaturedAutoPlay();
            }, { passive: true });

            // Measure overflow first (CSS already centers), then play entrance.
            updateOverflowUI();
            window.requestAnimationFrame(function() {
                updateOverflowUI();
                window.requestAnimationFrame(revealFeatured);
            });

            if (typeof ResizeObserver !== 'undefined') {
                const ro = new ResizeObserver(function() {
                    updateOverflowUI();
                });
                ro.observe(featuredTrack);
                featuredCards.forEach(function(card) {
                    ro.observe(card);
                });
            }

            window.addEventListener('resize', updateOverflowUI);
        }

        if (typeof lucide !== 'undefined' && lucide.createIcons) {
            lucide.createIcons({
                root: widget
            });
        }
    });
});
